module.exports = __webpack_public_path__ + "img/Slice 268@2x(3).aafdf7b9.png";